import { BlogPostContent } from '@/types/blog';
import { introSection } from './sections/intro';
import { worteSchoepfungSection } from './sections/worte-schoepfung';
import { neuronalesDilemmaSection } from './sections/neuronales-dilemma';
import { menschSeinSection } from './sections/mensch-sein';
import { meinungsfreiheitSection } from './sections/meinungsfreiheit';
import { demokratieSpracheSection } from './sections/demokratie-sprache';
import { machtstrukturenSection } from './sections/machtstrukturen';
import { fuehrungGefuehlSection } from './sections/fuehrung-gefuehl';
import { zenHaltungSection } from './sections/zen-haltung';
import { ausblickSection } from './sections/ausblick';

export const content: BlogPostContent = {
  sections: [
    introSection,
    worteSchoepfungSection,
    neuronalesDilemmaSection,
    menschSeinSection,
    meinungsfreiheitSection,
    demokratieSpracheSection,
    machtstrukturenSection,
    fuehrungGefuehlSection,
    zenHaltungSection,
    ausblickSection
  ]
};
